import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Elena saw the framework we needed before we could articulate it. The work has held up to every supervisory conversation since.",
    name: "Group Chief Risk Officer",
    role: "Tier-one European bank",
  },
  {
    quote:
      "Elena has a rare ability to make complex risk topics practical, relevant and engaging. Her programmes consistently receive outstanding feedback from both risk specialists and senior executives.",
    name: "Head of Academy",
    role: "Pan-European Stock Exchange",
  },
  {
    quote:
      "Many advisers can design frameworks. Elena's strength is making them work in practice. The result for us was a simpler, more effective approach that the business genuinely adopted.",
    name: "Chief Executive Officer",
    role: "UK Building Society",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-16 md:py-24 bg-[#0D0D0D] text-[#F9F8F6]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <p className="font-sans-body text-xs tracking-widest-2 uppercase text-[#9CDBD9] mb-6 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#9CDBD9]" />
              In their words
            </p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight font-medium">
              The voices of
              <br />
              <span className="italic text-[#9CDBD9]">the people I serve.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
          {TESTIMONIALS.map((t, idx) => (
            <motion.figure
              key={t.name + idx}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: idx * 0.1, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`testimonial-${idx}`}
              className="bg-[#0D0D0D] p-10 md:p-12 flex flex-col"
            >
              <Quote size={28} strokeWidth={1.2} className="text-[#9CDBD9] mb-8" />
              <blockquote className="font-serif-display text-xl md:text-2xl leading-snug text-[#F9F8F6] mb-10">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto">
                <p className="font-sans-body text-sm text-[#F9F8F6]">{t.name}</p>
                <p className="font-sans-body text-[11px] tracking-widest-2 uppercase text-[#9CDBD9] mt-1">
                  {t.role}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
